export function proportionalImageSizes( selector, options = {} ) {
	const defaults = {
		applyToParent: false,
	};

	const settings = { ...defaults, ...options };

	const images = document.querySelectorAll( selector );

	images.forEach( async ( imageElement ) => {
		const percentage = await proportionalWidth( imageElement );

		// Apply width to parent element if specified.
		if ( settings.applyToParent ) {
			imageElement.parentElement.style.width = `${ percentage }%`;
			return;
		}

		// Check if immediate parent is link, and if so, set width on parent instead.
		if ( imageElement.parentElement.tagName === 'A' ) {
			imageElement.parentElement.style.width = `${ percentage }%`;
			return;
		}

		imageElement.style.width = `${ percentage }%`;
	} );
}

export async function proportionalWidth( imageElement ) {
	// Ensure image is loaded.
	await new Promise( ( resolve ) => {
		if ( imageElement.complete ) {
			resolve();
		} else {
			imageElement.addEventListener( 'load', resolve );
		}
	} );

	// Expected aspect ratios range from 1 to 2.5. Aspect ratio of 1 results in 50% width, 2.5 results in 100% width.
	const scaleFactor = 0.525;

	const naturalWidth = imageElement.naturalWidth;
	const naturalHeight = imageElement.naturalHeight;

	if ( naturalHeight === 0 ) {
		return 50; // Avoid division by zero
	}

	// Calculate the aspect ratio
	const aspectRatio = naturalWidth / naturalHeight;

	// Calculate the percentage using the specified scale factor (0.525)
	const percentage = 50 + 50 * ( ( aspectRatio - 1 ) * scaleFactor );

	// Ensure that percentage is clamped between 50 and 100
	return Math.min( 100, Math.max( 50, percentage ) );
}

export default proportionalImageSizes;
